// reducer.js
import * as constants from './constants';

const INITIAL_STATE = {
  selectedCarVariantCode: null,
  selectedCarVariantData: null,
  selectedCarModelData: [],
  simulationCreditData: null,
};

const metadataReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_SELECTED_CAR_VARIANT_CODE:
      return { ...state, selectedCarVariantCode: action.payload };
    case constants.SET_SELECTED_CAR_VARIANT_DATA:
      return { ...state, selectedCarVariantData: action.payload };
    case constants.SET_SELECTED_CAR_MODEL_DATA:
      return { ...state, selectedCarModelData: action.payload };
    case constants.SET_SIMULATION_CREDIT_DATA:
      return { ...state, simulationCreditData: action.payload };
    case constants.CLEAR_SIMULATION_CREDIT_DATA:
      return { ...state, simulationCreditData: null };
    default:
      return state;
  }
};

export default metadataReducer;
